import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';

import Preloader from '../../Preloader';

import withComponentName from '../../../decorators/withComponentName';
import * as trendingActions from '../../../actions/trendingBarActions';

import loadable from '../../../utils/loadable';

import Styles from './styles.module.scss';

const Chart = loadable(() => import('react-google-charts'));

class TrendingGraphDropDown extends Component {
  constructor(props) {
    super(props);
    this.trendingGraph = null;
    this.state = {};
    autoBind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside(e) {
    const { trendingGraphOpened, actions } = this.props;
    if (
      this.trendingGraph
      && !this.trendingGraph.contains(e.target)
      && trendingGraphOpened && e.target
    ) {
      actions.toggleTrendingGraph();
    }
  }

  render() {
    const {
      trendingAssets,
    } = this.props;

    const data = trendingAssets.map((trendingAsset) => {
      const trendingTimes = +((trendingAsset.score / 100) + 1).toFixed(2);
      return [
        trendingAsset.topic.name,
        trendingTimes,
        `${trendingTimes}x`,
      ];
    });

    const options = {
      colors: ['#3971c1'],
      annotations: {
        stem: {
          color: 'transparent',
        },
        textStyle: {
          fontSize: 14,
          bold: false,
          italic: false,
          color: '#fff',
          auraColor: '',
        },
        alwaysOutside: true,
      },
      chartArea: {
        width: '100%',
      },
      legend: 'none',
      backgroundColor: '#353A3F',
      tooltip: {
        trigger: 'none',
      },
      bar: {
        groupWidth: '98%',
      },
      fontName: 'Lato',
      vAxis: {
        maxValue: 0,
        baselineColor: '#353A3F',
        textPosition: 'none',
        gridlines: {
          count: 0,
          color: 'transparent',
        },
      },
      hAxis: {
        textStyle: {
          fontName: 'Lato',
          fontStyle: 'normal',
          italic: false,
          fontSize: 14,
          color: '#ffffff',
        },
        gridlines: {
          count: 0,
          color: 'transparent',
        },
      },
    };

    const chartSection = !data.length ? (
      <p className="w-100 text-center">
        No trending graphs at the moment.&nbsp;
        Please review your Trending Period and Topic Class filters.
      </p>
    ) : (
      <Chart
        chartType="ColumnChart"
        data={[['', '', { role: 'annotation', type: 'string' }], ...data]}
        width="100%"
        height="400px"
        options={options}
        loader={(
          <Preloader
            loading
            centered
            static
            color="#353A3F"
          />
        )}
      />
    );

    return (
      <div className={Styles.trending_graph_dropdown} ref={(ref) => { this.trendingGraph = ref; }}>
        {chartSection}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...trendingActions }, dispatch),
});

const mapStateToProps = (state) => ({
  period: state.trendingBarReducer.period,
  trendingAssets: state.trendingBarReducer.trendingAssets,
  assetClasses: state.trendingBarReducer.assetClasses,
  allTrendingAssetClasses: state.trendingBarReducer.defaultTrendingClass,
  selectedTrendingClasses: state.trendingBarReducer.selectedTrendingClasses,
  trendingGraphOpened: state.trendingBarReducer.trendingGraphOpened,
});

export default withComponentName(
  connect(mapStateToProps, mapDispatchToProps)(TrendingGraphDropDown),
);
